import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Loginnew from "../Authentication/Auth";
import Logo from "../../assets/images/LogoNew.svg";
import { INVALID_VERIFY_LINK_MESSAGE } from "../../util/authResume";
import UboDashboard from "./UboDashboard";
import "./UboDashboard.scss";

const CompleteApplicationShell = ({ children }) => (
  <div className="fv_complete_application_login">
    <div className="form-content-container">
      <div className="form-content-header">
        <img src={Logo} alt="fv-bank" className="logo logo-dark form-content-logo" />
      </div>
      <div className="form-content-body with-shadow compact">
        <div className="form-content-body-header">Individual Verification</div>
        <div className="form-content-body-content">{children}</div>
      </div>
    </div>
  </div>
);

const CompleteApplication = () => {
  const location = useLocation();
  const { token } = useParams();
  const [error, setError] = useState("");
  const [context, setContext] = useState(null);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    setInitialized(false);
    const params = new URLSearchParams(location.search);
    const resolvedContext = {
      email: params.get("email") || "",
      ubo_id: token || params.get("ubo_id") || "",
    };

    if (!resolvedContext.ubo_id) {
      setError(INVALID_VERIFY_LINK_MESSAGE);
      setContext(null);
      setInitialized(true);
      return;
    }

    localStorage.setItem("ubo_id", resolvedContext.ubo_id);
    if (resolvedContext.email) {
      localStorage.setItem("email", resolvedContext.email);
    }
    setContext(resolvedContext);
    setError("");
    setInitialized(true);
  }, [location.search, token]);

  const loginForm = useMemo(() => ({
    redirectPath: `/complete-application/${context?.ubo_id || token}/dashboard`,
    type: "kyc",
    name: "Individual Verification",
    unauthUrl: `complete-application/${context?.ubo_id || token}`,
    allowStoredVerifyContext: false,
    allowKycEmailInput: true,
    completeApplication: true,
    verifyContext: {
      ubo_id: context?.ubo_id || token || "",
      email: context?.email || "",
    },
  }), [context?.email, context?.ubo_id, token]);

  if (!initialized) {
    return (
      <CompleteApplicationShell>
        <div className="fv_ubo_entry_skeleton" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </CompleteApplicationShell>
    );
  }

  if (error) {
    return (
      <CompleteApplicationShell>
        <div className="fv_ubo_error">Error: {error}</div>
      </CompleteApplicationShell>
    );
  }

  return (
    <div className="fv_complete_application_login">
      <Loginnew isUser form={loginForm} />
    </div>
  );
};

export default CompleteApplication;

export const CompleteApplicationDashboard = () => {
  const { token } = useParams();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (token) {
      localStorage.setItem("ubo_id", token);
    }
    setInitialized(true);
  }, [token]);

  if (!initialized) {
    return (
      <div className="fv_ubo_container fv_ubo_broker_dashboard">
        <div className="fv_ubo_entry_skeleton" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    );
  }

  if (!token) {
    return (
      <div className="fv_ubo_container fv_ubo_broker_dashboard">
        <div className="fv_ubo_error">Error: {INVALID_VERIFY_LINK_MESSAGE}</div>
      </div>
    );
  }

  return <UboDashboard brokerCompleteApplication />;
};
